import React, { useState } from 'react'
import { Modal, Button, Card, CardBody, CardHeader, CardTitle } from 'reactstrap'
import { useDispatch, flashSuccess, flashError } from "@/shared/components/flash"
import axios from 'axios'

const ResendInviteModal = ({ isOpen, toggle, selectedRows, program, setTrigger }) => {
    const dispatch = useDispatch()
    const [saving, setSaving] = useState(false);

    const onSubmit = values => {
        let formData = {
            recipients: selectedRows.map((item) => item.id)
        }

        setSaving(true)

        axios.post(`/organization/${program.organization_id}/program/${program.id}/inviteResend`, formData)
            .then((res) => {
                if (res.status == 200) {
                    setTrigger(Math.floor(Date.now() / 1000))
                    flashSuccess(dispatch, 'Participants re-invited successfully!')
                    setSaving(false)
                    toggle()
                    // window.location.reload()
                }
            })
            .catch((err) => {
                flashError(dispatch, err.response.data)
                setSaving(false)
            });
    }

    return (
        <Modal className={`modal-action modal-lg`} isOpen={isOpen} toggle={toggle}>
            <Card className='w-100'>
                <CardHeader tag="h3">
                    Resend Invitation
                    <Button className='btn float-end' close onClick={toggle} />
                </CardHeader>
                <CardBody className='text-left'>
                    {saving && 'Resending Invitation, please wait...'}
                    <CardTitle >Participant List to be Invited: </CardTitle>
                    <div className='mb-4'>
                        {selectedRows.map((item, index) => (
                            <li key={index}>
                                <strong>{item.last_name}, {item.first_name}</strong>
                            </li>
                        ))}
                    </div>
                    <div className='d-flex justify-content-end'>
                        <Button className='btn-sm mr-2' color='primary' onClick={onSubmit}>Resend Invitation</Button>
                        <Button className='btn-sm' color='outline-primary' onClick={toggle}>Cancel</Button>
                    </div>
                </CardBody>
            </Card>
        </Modal>
    )
}


export default ResendInviteModal;
